<template>
  <div class="mall-toast">
    <img class="mall-toast__icon" :src="icon" alt="" />
    <div class="mall-toast__text">
      <span class="mall-toast__title">{{ title }}</span>
      <span v-if="message" class="mall-toast__message">{{ message }}</span>
    </div>
  </div>
</template>

<script>
// 하단 버튼 위에 잠깐 노출되는 안내 (duration 후 close)
export default {
  name: 'MallToast',
  props: {
    title: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      default: '',
    },
    duration: {
      type: Number,
      default: 3000,
    },
    // 'error' (경고 아이콘) | 'success' (체크 아이콘)
    type: {
      type: String,
      default: 'error',
    },
  },
  computed: {
    icon() {
      return this.type === 'success'
        ? require('@/assets/mall/icn_check_line_blue.svg')
        : require('@/assets/mall/icn_warning_circle_red.svg')
    },
  },
  mounted() {
    this.timer = setTimeout(() => this.$emit('close'), this.duration)
  },
  beforeDestroy() {
    clearTimeout(this.timer)
  },
}
</script>

<style scoped>
/* 하단 고정 버튼 영역(16 + 54px) 위 16px */
.mall-toast {
  position: fixed;
  bottom: 86px;
  left: 50%;
  display: flex;
  width: calc(100% - 32px);
  max-width: 568px;
  padding: 11px 15px;
  align-items: center;
  gap: 8px;
  border: 1px solid #333D4B;
  border-radius: 12px;
  background: rgba(0, 12, 30, 0.8);
  box-sizing: border-box;
  transform: translateX(-50%);
  z-index: 20;
}

.mall-toast__icon {
  display: block;
  flex-shrink: 0;
  width: 20px;
  height: 20px;
}

.mall-toast__text {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 2px;
  font-family: Pretendard;
  font-weight: var(--font-weight-medium);
  /* 긴 문구가 글자 중간에서 줄바꿈되지 않도록 */
  word-break: keep-all;
}

.mall-toast__title {
  color: #FFF;
  font-size: var(--font-size-md);
  line-height: var(--line-height-normal);
}

.mall-toast__message {
  color: #D1D6DB;
  font-size: var(--font-size-sm);
  line-height: var(--line-height-normal);
}
</style>



// WEBPACK FOOTER //
// src/components/new/molecules/MallToast.vue